<template>
  <div class="current-location">
    <div class="flex pb-2 items-center" @click="route">
      <span class="location-icon">
      <LocationIcon />
      </span>
      <span class="title" v-html="title" />
      <img width="14px" height="14px" class="ml-2" :src="`${$store.state.appUrl}/img/pwa/icon_edit.svg`" />
    </div>
    <div class="address">
      <span> {{ address }} </span>
    </div>
  </div>
</template>
<script>
import mixins from "../../config/mixins";
import LocationIcon from "../Icons/LocationIcon.vue";
export default {
  mixins: [mixins.location],
  props: {
    through: {
      type: String,
      default: "dashboard"
    }
  },
  components: {
    LocationIcon
  },

  mounted() {
    if (!this.$getState('anotherLocation')) {
      this.getLocation()
    }
  },

  computed: {
    isAnotherLocation() {
      return this.$getState('anotherLocation')
    },

    anOtherLocationTile() {
      let split = this.isAnotherLocation.title.split(' ')
      let restOf = split.length ? split.slice(1).join(" ") : ""
      return `<span class="text-primary">${split[0]} </span> <span class="text-secondary">${restOf}</span>`;
      // return `${split[0]} ${restOf}`
    },
    title() {
      return this.isAnotherLocation ? this.anOtherLocationTile : '<span class="text-primary">Current</span> <span class="text-secondary">Location</span>'
    },
    address() {
      return this.isAnotherLocation ? this.isAnotherLocation.address : this.$getState('userAddress') || 'Please Allow borwser to find you'
    }
  },
  methods: {
    route() {
      this.$setState('setFromComponent', this.through)
      this.$router.push('/add-location')
    }
  }
}
</script>
